<template>
    <div class="answer">
        <div class="question-content-wrapper">
            <div class="comment-content-wrapper" @click.stop="goDetailComment(comment)">
                <p v-if="!comment.is_child" :class="['comment-left', {'active': comment.is_vote_up}]" @click.stop="onApproval(comment)">
                    <span>{{comment.vote_up_num}}</span>
                    <span class="text">{{ comment.is_vote_up ? '已赞' : '赞同'}}</span>
                </p>
                <div class="comment-desc">
                    <span class="tag adopted" v-if="comment.is_accept">已采纳</span>
                    <template v-if="comment.is_child">
                        <span>回复</span>
                        <span
                            class="comment-name"
                            @click.stop="goHomePage(comment.parent_user)">
                            {{ comment.parent_user.nick_name }}
                        </span>
                        <span> 的回答：</span>
                    </template>
                    <span v-else>回答：</span>
                    “ <span class="desc">{{ comment.simple_comment }}</span> ”
                    <span v-if="comment.isViewDetail" class="link" @click.stop="goDetailComment(comment)">
                        查看详情
                        <img class="share-icon" src="../../../images/personal_center/share.png" alt="">
                    </span>
                </div>
            </div>
        </div>
        <!-- 底部按钮 -->
        <div class="comment-bottom-content">
            <p v-if="isSelf" class="answer-text delete" @click.stop="deleteArticle(comment)">
                <i class="smart-img"></i>
                <span>删除回答</span>
            </p>
            <p class="topic-people">{{comment.created_on}}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        comment: {
            type: Object,
            default: () => {}
        },
        isSelf: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        // 前往个人主页
        goHomePage (userInfo) {
            this.$emit('goHomePage', userInfo)
        },
        // 跳转到详情的评论去
        goDetailComment (comment) {
            localStorage.setItem('commentId', comment.id)
            let routeData = this.$router.resolve({
                name: 'Question',
                params: {
                    wid: comment.topic_id
                },
                query: {
                    type: 'answer'
                }
            })
            window.open(routeData.href, '_blank')
        },
        onApproval (comment) {
            this.$emit('onApproval', comment)
        },
        deleteArticle (comment) {
            this.$emit('deleteArticle', comment.topic_id, comment.id)
        }
    }
}
</script>

<style lang="scss" scoped>
    .question-content-wrapper {
        font-size: 14px;
        color: #63656e;
        cursor: pointer;
        margin-top: 16px;
        .comment-content-wrapper {
            display: flex;
            align-items: flex-start;
            .comment-left {
                flex-shrink: 0;
                width: 43px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                font-size: 12px;
                line-height: 16px;
                background: #f0f1f5;
                border-radius: 2px;
                font-weight: 500;
                color: #313238;
                margin-right: 12px;
                cursor: pointer;
                .text {
                    font-weight: normal;
                    color: #63656e;
                }
                &.active, &:hover {
                    color: #3a84ff;
                    background: #e1ecff;
                    .text {
                        color: #3a84ff;
                    }
                }
            }
            .comment-desc {
                flex: 1;
                font-size: 14px;
                line-height: 22px;
                color: #313238;
                position: relative;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                word-break: break-all;
                .comment-name {
                    color: #3a84ff;
                }
                .adopted {
                    padding: 0px 3px;
                    color: #14a568;
                    border: 1px solid #14a568;
                }
                .link {
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    background: #fff;
                    padding: 0 15px;
                    cursor: pointer;
                    color: #3a84ff;
                    .share-icon {
                        height: 16px;
                        width: 16px;
                        margin-top: -1px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// answer.vue?361d28a6